import styles from './LoginPage.module.css';
import BrandPanel from '../components/login/BrandPanel';
import ResetPasswordForm from '../components/login/ResetPasswordForm';

const ResetPasswordPage = () => {
  return (
    <div className={styles.page}>
      {/* Left Column */}
      <div className={styles.leftCol}>
        <BrandPanel />
      </div>

      {/* Right Column */}
      <div className={styles.rightCol}>
        <ResetPasswordForm />
      </div>
    </div>
  );
};

export default ResetPasswordPage;
